module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_8011.42a86369.png";